import React from "react";
import OrderHistory from "./OrderHistory";

export const Lists = () => {
  return <OrderHistory />;
};
